import { createContext } from "react";

export const SuspendHeaderClassContext = createContext<
	((flag: boolean) => void) | null
>(null);
